<div class="pulse-wrapper" [class.loading]="loading" [class.error]="error">
  <div class="pulse pulse-lg"></div>
  <div class="pulse pulse-md"></div>
  <div class="pulse"></div>
  <!-- <img src="../assets/images/icon-check.png"> -->
</div>
